import { Routes, Route } from "react-router-dom";

import Background from './components/Background/Background'
import Exercise from './components/Exercise/Exercise'
import Login from './components/Login/Login'
import Profile from './components/Login/Profile'
import Signup from './components/Login/Signup'
import SignupCodePage from './components/SignupCodePage/SignupCodePage'
import Home from './components/Home/Home'

function App() {
  return (
    <Background>
      <Routes>
        <Route path="/exercise/:id/*" element={<Exercise />} />
        <Route path="/signup_url" element={<SignupCodePage />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Home />} />
      </Routes>
    </Background>
  );
}

export default App;
